import React from 'react';
import { MdSearch } from 'react-icons/md';

import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

export type DsSearchFieldProps = React.InputHTMLAttributes<HTMLInputElement>;

const Wrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  max-width: 320px;

  svg {
    position: absolute;
    left: 10px;
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.textMuted};
    pointer-events: none;
  }

  input {
    width: 100%;
    height: 40px;
    border-radius: ${({ theme }) => theme.radius.pill};
    border: 1px solid ${({ theme }) => theme.colors.border};
    background: ${({ theme }) => theme.colors.page};
    color: ${({ theme }) => theme.colors.textPrimary};
    padding: 0 12px 0 34px;
    font-family: ${({ theme }) => theme.font.family};
    font-size: ${({ theme }) => theme.font.sizeMd};
  }

  input::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  input:focus {
    ${anelDeFoco('-1px')}
  }
`;

export const DsSearchField: React.FC<DsSearchFieldProps> = ({
  type = 'search',
  placeholder = 'Buscar',
  ...rest
}) => (
  <Wrap>
    <MdSearch aria-hidden="true" />
    <input type={type} placeholder={placeholder} {...rest} />
  </Wrap>
);
